import type { DatasetPlanPositioningContextValues } from "./dataset-plan-positioning.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "DatasetPlanPositioningContext",
  providerName: "DatasetPlanPositioningProvider",
};

export const DatasetPlanPositioningContext =
  createContext<DatasetPlanPositioningContextValues | null>(null);

export const useDatasetPlanPositioningContext = () => {
  const contextValue = useContext(DatasetPlanPositioningContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
